<template>
    <div>
        <ul class="nav nav-pills">

            <li role="presentation"><a href="#" @click="addDesconto" class="btn btn-primary" ><i class="fa fa-tasks"></i> Solicitar Desconto </a></li>
        </ul>
        <br>
        <div>
            <v-table :column="colunas" :data="listaDescontos"  :actions="actionsTable" @edit='showDesconto' ></v-table>

        </div>

        <div class="modal fade" id="ModalDescontos" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title"></h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-md-12">
                                <label>Selecione um Cliente </label>
                                <v-select v-model="desconto.distribuidor" :options="listaDistribuidor" :disabled="!showDistribuidor"  @search="loadDistribuidor"></v-select>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <label>Obs.</label>
                                <textarea rows="3" class="form-control" v-model="desconto.obs" placeholder="Digite algo sobre o desconto."></textarea>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Produto</label>
                                <input id="input-codigo-produto" type="number" class="form-control" v-model="codigo" @keyup="searchProduto" :disabled="disableCodigo">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-primary">
                                <h5>{{ labelProduto }} </h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <label>% Desconto </label><small> Percentual do desconto</small>
                                <input class="form-control" v-model="desconto.desconto" type="text"  v-money="money" @keyup="searchProduto" :disabled="disableCodigo">
                            </div>
                            <div class="col-sm-4">
                                <label>Preço sem desconto</label>
                                <input v-money="money" v-model="desconto.preco" class="form-control" readonly>
                            </div>
                            <div class="col-sm-4">
                                <label>Preço com desconto</label>
                                <input v-money="money" v-model="desconto.preco_desconto" class="form-control" readonly>
                            </div>

                        </div>



                    </div>
                    <div class="modal-footer">
                        <div v-if="parseInt(desconto.id) > 0">
                            <button type="button" class="btn btn-block" data-dismiss="modal"><span class="fa fa-trash"></span> Deletar desconto.</button>
                        </div>
                        <br>

                        <button type="button" class="btn btn-primary" @click="salvarDesconto" :disabled="parseInt(desconto.id) > 0">Salvar</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" >Fechar</button>
                        <button type="button" class="btn btn-success" @click="aprovar" :disabled="parseInt(desconto.id) <= 0">Aprovar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import vSelect from "vue-select";
    import {VMoney} from 'v-money'
    export default {
        name: "List",
        components: {vSelect},
        directives: {money: VMoney},
        data() {
            return {
                money: {
                    decimal: '.',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                colunas:[
                    ["Código","codigo"],["Distribuidor","distribuidor"],['Data','data'],['Produto','produto'],['Valor com desconto','desconto'],['Status','status']
                ],
                codigo: '',
                listaDescontos: [],
                listaDistribuidor: [],
                produtos: [],
                labelProduto: '',
                preco: 0,
                distribuidor: '',
                actionsTable:['edit'],
                showDistribuidor: true,
                disableCodigo: false,
                desconto: {
                    id: null,
                    distribuidor: '',
                    desconto: 0.00,
                    preco_desconto: 0.00,
                    preco: 0.00,
                    status: 'BLOQUEADO',
                    produto: null,
                    obs: '',
                }
            }
        },
        methods: {
            aprovar:function(){
                var vm = this;
                axios.post('/adm/descontos/aprovar',{ id: this.desconto.id }).then(function(response){
                  vm.getLoad();
                  console.log(response.data);
                })
            },
            salvarDesconto:function(){
                var vm = this;
                console.log(this.desconto);
                var Toast = vm.$swal.mixin({
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', vm.$swal.stopTimer);
                        toast.addEventListener('mouseleave', vm.$swal.resumeTimer);
                    }
                })
              if(this.desconto.produto === ''){
                  return Toast.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Ops, Informe um produto válido'
                  });
              }
              if(parseFloat(this.desconto.desconto) <= 0){
                  return Toast.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Ops, O desconto não pode ser menor ou igual a zero.',
                  });
              }
              if(this.desconto.distribuidor === ''){
                  return Toast.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Ops, Informe um cliente válido',
                  });
              }

              axios.post('/adm/descontos',vm.desconto).then(function(response){
                  let obj = response.data;
                  $('#ModalDescontos').modal('hide');
                  vm.getLoad();
              })
            },
            getLoad:function () {

                var vm = this;
                axios.get('/adm/descontos/show').then(function (response) {
                    vm.formatDataToTable(response.data)

                })
            },
            formatDataToTable:function(arrayData){
                var vm = this
                arrayData.forEach(function (value) {
                    vm.listaDescontos.push({
                        id: value.id,
                        codigo: value.distribuidor.codigo,
                        distribuidor: value.distribuidor.nome,
                        data: moment(value.created_at).format('DD/MM/YYYY H:m:s'),
                        produto: value.produto.nome,
                        desconto: parseFloat(value.valor_desconto).toFixed(2).toString().replace('.',','),
                        status: value.status
                    })
                })
            },
            searchProduto: function(){

                if(this.codigo.length === 0 ){
                    this.labelProduto = "";
                    this.desconto.produto = '';
                }else	if(typeof(this.produtos[this.codigo]) === 'undefined' && this.codigo !== 0){

                    this.labelProduto = "Produto não encontrado";
                }else{
                     this.desconto.produto = this.produtos[this.codigo].id;
                     this.labelProduto = this.produtos[this.codigo].nome;
                     this.preco = this.produtos[this.codigo].preco;
                     this.desconto.preco_desconto = parseFloat(this.preco - parseFloat(this.preco * (parseFloat(this.desconto.desconto) /100))).toFixed(2);
                     this.desconto.preco = this.preco;
                }
            },
            getProdutos:function(){
                $('.loading').show();
                var vm = this;
                axios.get('/distribuidor/produtos/list').then(function(response){
                    let produtos = response.data;
                    produtos.forEach(function(produto){
                        vm.produtos[""+parseInt(produto.codigo)] = {
                            id: produto.id,
                            codigo: produto.codigo,
                            nome: produto.nome,
                            preco: parseFloat(produto.pivot.preco).toFixed(2),
                            disponivel:produto.pivot.disponivel
                        };
                    });
                    $('.loading').hide();
                }).catch(function(error){
                    //alert("Erro ao carregar Produtos");
                    console.log(error);
                    $('.loading').hide();
                });
            },
            addDesconto:function(){
                this.getProdutos();
                this.desconto = {
                    id: null,
                    distribuidor: '',
                    produto: '',
                    status: 'BLOQUEADO',
                    desconto: 0.00,
                    preco_desconto: 0.00,
                    preco: 0.00
                };
                this.preco = 0.00;
                this.disableCodigo = false;
                $('#ModalDescontos').modal();
                $('#modal-title').html('Solicitação de Desconto');
            },
            showDesconto:function(id) {
                if(typeof id ==='undefined'){
                    console.log('id indefinido');
                    return;
                }
                var vm = this;
                this.getProdutos();
                this.showDistribuidor = false;
                axios.get('/adm/descontos/show?id='+id).then(function (response) {
                    let obj = response.data;
                    console.log(obj);
                    vm.disableCodigo = true;
                    vm.desconto = {
                        desconto: parseFloat(obj.desconto).toFixed(2),
                        obs: obj.obs,
                        status: obj.status,
                        preco: parseFloat(obj.preco).toFixed(2),
                        distribuidor: { label: obj.distribuidor.nome, value: obj.distribuidor.id },
                        produto: obj.produto.id,
                        preco_desconto: parseFloat(obj.valor_desconto).toFixed(2)
                    };
                    vm.labelProduto = obj.produto.nome;
                    $('#modal-title').html('Visualizando Desconto ');
                    $('#ModalDescontos').modal();
                })
            },
            loadDistribuidor:function(key){

                var vm = this;
                this.listaDistribuidor = [];
                axios.get('/adm/distribuidores/combo',{ params: {query:key, classe: 'H'} }).then(function (response) {

                    console.log(response.data);
                    var obj = response.data;
                    obj.forEach(function (v) {
                        vm.listaDistribuidor.push({value:v.id,label:v.codigo+' - '+v.nome});
                    });

                }).catch(function (error) {
                    console.log(error);
                });
            },
        },
        mounted(){
            this.getLoad();
        }
    }
</script>

<style scoped>
    @import '~sweetalert2/dist/sweetalert2.min.css';
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_prohotel/List.vue